import { Scene } from "phaser";
import { GButton } from "../gameobjects/GButton";
//import { TicketsList } from "../gameobjects/TicketsList";
import { TicketsListDesktop } from "../gameobjects/TicketsListDesktop";
import { unixToDate, getCurrentDraw,formatUnixTimestamp  } from '../utils';
import { TimerObject } from "../gameobjects/TimerObject";


const COLOR_DARK = 0x212121;


export class MyTicketsSceneDesktop extends Scene {
    
    constructor() {
        super("MyTicketsSceneDesktop");
    }

    init(data) {
       
    }


    create(){

         //this.background = "#ccc"
         const storedParamsJSON = localStorage.getItem('gameParams');
         const storedParams = JSON.parse(storedParamsJSON) || {};
 
         const gamecode = storedParams['gamecode'] || undefined;
         this.updateDrawCall(gamecode);

        const HeaderY = 62
        //console.log("myticket:: CREATE")
        this.numberGrid = [];
        
        this.title = this.add.text(this.scale.width/2, HeaderY , `MY TICKETS`,  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }).setOrigin(0.5);
        this.title.setFontStyle('700')

        const ButtonBack = new GButton(this,this.scale.width/2-360, HeaderY, {
            texturePack: "pack", 
            text: {
                value: 'BACK',
                style:  { fontFamily: 'Oswald', fontSize: 20, color: '#ffffff' }
            },
            icon: {
                image: 'arrow back_ios.png',
                scale: 0.4,
                align: 'left',
                x: -30
            },
            onClick: () => {
                this.scene.start("MenuScene");
             }
        });


        this.currentDrawInfo = this.registry.get('currentDraw');
        this.itemList = this.currentDrawInfo.tickets;



        const containerY = HeaderY;

        this.TicketsHeader = this.add.nineslice(this.scale.width/2,  containerY + 52, 'pack', 'header-main.png', this.scale.width*0.8, 52, 32, 32,16,16);

        this.DrawDate = formatUnixTimestamp( this.registry.get('drawdate'));


        this.drawDateDate = this.add.text(this.scale.width/2,  containerY +54, this.DrawDate ,  { fontFamily: 'Oswald', fontSize: 14, color: '#ffffff' }).setOrigin(0.5,0);
        this.drawDateDate.setFontStyle('700')


        this.drawNumberText = this.add.text(this.scale.width/2,  containerY+30 , `DRAW NO. ${this.currentDrawInfo.draw_date_id}` ,  { fontFamily: 'Oswald', fontSize: 16, color: '#ffffff' }).setOrigin(0.5,0);
        this.drawNumberText.setFontStyle('700')



        this.noTicketsText = this.add.text(this.scale.width/2,   containerY + 216 +52/2 + 210/2, `NO TICKETS YET...` ,  { fontFamily: 'Oswald', fontSize: 16, color: '#ffffff' }).setOrigin(0.5);
        this.noTicketsText.setFontStyle('700')

        this.noTicketsText.setVisible(false);

        const containerHeight = 460*2

        this.boxHight = this.scale.height/2;

        if(this.itemList.length == 0){
            this.boxHight = 186;
            this.noTicketsText.setVisible(true);
        }


        this.TicketsSecondHeader = this.add.nineslice(this.scale.width/2,  containerY + 216, 'pack', 'header-main.png', this.scale.width*0.8, 52, 32, 32,16,16);

        // Load and blur the background image
        this.backgroundImage = this.add.image(0, 0, 'lotto-bg');
        this.backgroundImage.setOrigin(0, 0);
        this.backgroundImage.setScale(
            this.scale.width / this.backgroundImage.width,
            this.scale.height / this.backgroundImage.height
        );

        // Create the mask graphics
        this.boxGraphics = this.add.graphics();
        this.boxGraphics.fillStyle(0xaaaaaa, 0.1);
        this.boxGraphics.fillRoundedRect(
            this.scale.width/2- this.scale.width*0.8/2, containerY + 78,this.scale.width*0.8, 96, { tl: 0, tr: 0, bl: 32, br: 32 }
        );

        this.boxGraphics.fillRoundedRect(
            this.scale.width/2- this.scale.width*0.8/2,  containerY + 216 +52/2,this.scale.width*0.8, 210, { tl: 0, tr: 0, bl: 32, br: 32 }
        );

        // Apply the mask to the background image
        this.backgroundImage.setMask(new Phaser.Display.Masks.GeometryMask(this, this.boxGraphics));

        // Add blur effect
        this.backgroundImage.preFX.addBlur(1, 2, 2, 2, 0xffffff, 4);

        


    


        const ButtonBuyTickets = new GButton(this, this.scale.width/2, this.scale.height -48, {
            texturePack: "pack", 
            idleTexture: 'Button - Primary - Default.png',
            clickedTexture: 'Button - Primary - Clicked.png',
            disabledTexture: 'Button - Primary - Disabled.png',
            text: {
                value:'BUY TICKET',
                style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
            },
            // nineslice: {
                
            // },
            onClick: () => {
                if(window.isMobile){
                    this.scene.start("BuyTicketScene")
                }else{
                    this.scene.start("BuyTicketSceneDesktop")
                }
             }
        });        

        ButtonBuyTickets.setScale(0.5);

        this.noTicketsText.setToTop()

        this.timerObject = new TimerObject(this, this.scale.width/2, 108);   
        this.timerObject.postFX.addGlow(0x00aaa0, 1, 0, false, 0.4, 18);
        this.timerObject.setScale(0.5);
        this.timerObject.hideNextDraw()
        const boundsTimer = this.timerObject.getBounds()
        this.timerObject.setPosition(this.scale.width/2 - boundsTimer.width/2, 108)


        this.panel = this.rexUI.add.scrollablePanel({
            x: this.scale.width/2, 
            y: containerY +240,
            width:  this.scale.width*0.8,
            height: 10,
            originY: 0,

            scrollMode: 0,
            mouseWheelScroller: {
                focus: true,
                speed: 0.1
            },
            expand: {panel:false},
            // background: this.rexUI.add.roundRectangle({
            //     color: COLOR_DARK,
            //     // strokeColor:"#FFFFF",
            //     radius: { tl: 0, tr: 0, bl: 32, br: 32 }
            // }),
            panel: {
                child: this.CreatePanel(this),
                pointerEvents: false, //  disables pointer/touch dragging
                //mask: { top: 300, },
            },
         
            space: { left: 0, right: 0, top: 10, bottom: 30, panel: 10}
        })

                
        this.panel.setVisible(false);

        this.updateTicketList(this.itemList)

        this.panel.layout()

    }

    CreatePanel(scene) {

        var rowCount = 1 
        if(this.itemList.length > 0){
            rowCount = Math.ceil(this.itemList.length/4)
        }

        this.gridSizer  = scene.rexUI.add.gridSizer(0,0,{
            orientation: 'vertical',
            width: scene.scale.width*0.8,
            space: { 
                left: 16,
                right: 0,
                top: 0, 
                bottom: 0, 
                column: 224, 
                row: 114
            },
            // background: this.rexUI.add.roundRectangle({
            //     color: COLOR_DARK,
            //     // strokeColor:"#FFFFF",
            //     radius: { tl: 0, tr: 0, bl: 32, br: 32 }
            // }),
            column: 4,  // col: 0
            //columnProportions: [1, 1, 1, 1], // make both columns 50%
            row: rowCount+1,
        })

        this.gridSizer.setOrigin(0,0.5)
        return this.gridSizer;
    }

    async updateDrawCall(gamecode) {
        const response = await getCurrentDraw(gamecode); 

        if(response.status !== 200 ){
            this.scene.start("ErrorScene", {message: "No Player Information"});
            return;
        }

        //console.log("myticket:: response from CURRENT")
        this.currentDrawInfo  = response.data
        this.registry.set('my-tickets', this.currentDrawInfo.tickets);
        this.registry.set('currentDraw', this.currentDrawInfo);

        if (this.currentDrawInfo.tickets.length > 0){
            this.noTicketsText.setVisible(false);
        }
        //this.updateTicketList(this.currentDrawInfo.tickets)
    }


    updateTicketList(itemList){
        
        try {
            this.panel.getElement('panel').removeAll(true);    
        } catch (error) {
            console.log(error)
        }
        if(itemList.length > 0){
            this.panel.setVisible(true);
            this.panel.setMinSize(this.panel.width, 236).layout();
        }
        

        
        for (let index = 0; index < itemList.length; index++) {
           const element = itemList[index];
                      
           var lastBoxY = 360;
           this.currentBound = 20
       
           this.numberGrid[index] = new TicketsListDesktop(this, 0 , 0, {numbersArray: itemList[index], ticketNumber: index });

           const bounds = this.numberGrid[index].getBounds()
            
           lastBoxY = bounds.height + bounds.y + 50
            
           this.currentBound = bounds.height;

           const column = index % 4;
           const row = Math.floor(index / 4);
           console.log("column", column)
           console.log("row", row)

            this.gridSizer.add(
                this.numberGrid[index],
                column,
                row,
                'center',
                0,
                true
            );
        
        //    this.panel
        //    .getElement('panel')
        //    .add(
        //         this.numberGrid[index],
        //         {
        //             proportion: 1,
        //             align: 'left',
        //             padding: { left: 20, right: 0, top: 0 , bottom: this.currentBound + 36},
        //             expand: false,
        //             fitRatio: 0,  // true
        //             offsetX: 0,
        //             //offsetY: lastBoxY,
        //         }
        //    );
        //    this.panel
        //    .getElement('panel')
           
        }

        this.gridSizer.layout();

        this.panel
        .getElement('panel')
        //.addSpace()
        .layout()

        //this.panel.setMinSize(this.panel.width, 346*2).layout();

         this.panel.layout()

    }

}